(function () {
	'use strict';

	angular
		.module('franchiser.components')
		.controller('CompanyFormFranchiserController', CompanyFormFranchiserController)

	/** @ngInject */
	function CompanyFormFranchiserController($timeout, $state, $q, $stateParams, CategoryService, LoadingHelper, ClusterService,
		RegionalService, CompanyService, CompanyStatusService, CompanyEconomicGroupService, CityService, StateService, AuthenticationService,
		UtilHelper, sweetAlert, SYSTEM_MODULES) {
		const vm = this;

		let allCities = [];

		vm.changeTab = tabId => {
			vm.selectedTab = tabId;
		}

		// Data
		vm.saveCompany = () => {
			if (!vm.selectedStatus) {
				UtilHelper.setErrorMessageForm('.status');
				return;
			}

			if (!vm.selectedCategory) {
				UtilHelper.setErrorMessageForm('.category');
				return;
			}

			if (!vm.selectedEconomicGroup) {
				UtilHelper.setErrorMessageForm('.economicGroup');
				return;
			}

			if (!vm.selectedState || vm.selectedState.Id == 0) {
				UtilHelper.setErrorMessageForm('.state');
				return;
			}

			if (!vm.selectedCity || vm.selectedCity.Id == 0) {
				UtilHelper.setErrorMessageForm('.city');
				return;
			}

			vm.companyData.Address.StateId = vm.selectedState.Id;
			vm.companyData.Address.CityId = vm.selectedCity.Id;

			LoadingHelper.startLoading('.loading-holder');

			let companyDataPost = {
				CompanyIdParent: vm.companyData.CompanyIdParent,
				AddressId: vm.companyData.AddressId,
				Id: vm.companyData.Id,
				UniqueCode: vm.companyData.UniqueCode,
				ExternalCode: vm.companyData.ExternalCode,
				StatusId: vm.selectedStatus.Id,
				CategoryId: vm.selectedCategory.Id,
				EconomicGroupId: vm.selectedEconomicGroup.Id,
				RegionalId: vm.selectedRegional ? vm.selectedRegional.Id : null,
				ClusterId: vm.selectedCluster ? vm.selectedCluster.Id : null,
				FantasyName: vm.companyData.FantasyName,
				CorporateName: vm.companyData.CorporateName,
				Url: vm.companyData.FantasyNameUrl,
				RegistrationDate: vm.companyData.RegistrationDate,
				UpdateDate: vm.companyData.UpdateDate,
				Address: vm.companyData.Address,
				Active: vm.companyData.Active,
				CNPJ: vm.companyData.CNPJ,
				IE: vm.companyData.IE,
				CompanyEmails: vm.companyData.CompanyEmails,
				CompanyPhones: vm.companyData.CompanyPhones
			};

			if (!companyDataPost.Id) {
				CompanyService
					.post(companyDataPost)
					.then(success => successCallback(success, true), errorCallback);
			} else {
				CompanyService
					.put(companyDataPost)
					.then(successCallback, errorCallback);
			}
		}

		vm.getCities = preSelectedCityId => {
			delete vm.selectedCity;

			vm.cities = [];
			vm.cityPlaceholder = 'AGUARDE...';

			return CityService
				.getByState(vm.selectedState.Id)
				.then(success => {
					if (!success.length)
						vm.cityPlaceholder = 'NENHUM RESULTADO';
					else
						vm.cityPlaceholder = 'ESCOLHA A CIDADE';

					allCities = success;

					if (preSelectedCityId)
						vm.selectedCity = allCities.find(city => (city.Id == preSelectedCityId));
				}, error => {
					UtilHelper.errorCallback(error);
				})
		}

		vm.searchCities = search => {
			if (!search) {
				vm.companies = [];
				return;
			}

			vm.cities = allCities.filter(company => filterCity(company, search));
		}

		vm.changeCompanyStatus = status => vm.companyData.Active = status;

		vm.changeCompanyOpeningProcess = isInProcess => vm.companyData.InOpeningProcess = isInProcess;

		init();

		// Unit data
		function successCallback(success, isPost) {
			if (isPost) {
				formatDates(success);

				vm.companyData = success;
				vm.companyData.Address = success.Address;

				vm.companyForm.reset();

				sweetAlert.swal({
					title: 'Empresa cadastrada com sucesso!',
					html: `Código único da empresa: <strong>${vm.companyData.UniqueCode}</strong>`,
					type: 'success',
					confirmButtonText: 'Editar empresa',
					showCancelButton: true,
					cancelButtonText: 'Fechar',
					allowOutsideClick: false,
					allowEscapeKey: false
				}).then(response => {
					if (response.value) {
						$timeout(() => {
							$state.go('app.franchiser-companies-edit', {
								companyId: vm.companyData.Id
							}, {
								notify: false
							});
						})
					}
				})
			} else
				UtilHelper.successCallback('update');

			LoadingHelper.stopLoading('.loading-holder');
		}

		function errorCallback(error) {
			LoadingHelper.stopLoading('.loading-holder');
			UtilHelper.errorCallback(error);
		}

		function filterCity(city, search) {
			if (city.Name == null)
				city.Name = '';

			if (city.Name.toLowerCase().includes(search.toLowerCase()))
				return city;
		}

		function formatDates(companyData) {
			if (companyData.RegistrationDate)
				companyData.RegistrationDateFormatted = moment(companyData.RegistrationDate).format('DD/MM/YYYY HH:mm:ss');
			else
				companyData.RegistrationDateFormatted = '-';

			if (companyData.UpdateDate)
				companyData.UpdateDateFormatted = moment(companyData.UpdateDate).format('DD/MM/YYYY HH:mm:ss');
			else
				companyData.UpdateDateFormatted = '-';
		}

		function getCompany() {
			const companyId = $stateParams.companyId;

			if (!companyId) {
				vm.showExtraData = true;
				LoadingHelper.stopLoading('.loading-holder');
				return;
			}

			CompanyService
				.get(companyId)
				.then(success => {
					formatDates(success);

					vm.companyData = success;

					vm.showExtraData = true;

					if (vm.companyData.ClusterId)
						vm.selectedCluster = vm.clusters.find(cluster => (cluster.Id == vm.companyData.ClusterId));

					if (vm.companyData.RegionalId)
						vm.selectedRegional = vm.regionals.find(group => (group.Id == vm.companyData.RegionalId));

					if (vm.companyData.StatusId)
						vm.selectedStatus = vm.status.find(status => (status.Id == vm.companyData.StatusId));

					if (vm.companyData.CategoryId)
						vm.selectedCategory = vm.categories.find(category => (category.Id == vm.companyData.CategoryId));

					if (vm.companyData.EconomicGroupId)
						vm.selectedEconomicGroup = vm.economicGroups.find(economicGroup => (economicGroup.Id == vm.companyData.EconomicGroupId));

					if (vm.companyData.Address) {
						vm.companyData.Address = success.Address;
						vm.selectedState = vm.states.find(state => (state.Id == vm.companyData.Address.City.StateId));

						vm.getCities(vm.companyData.Address.City.Id);
					}

					LoadingHelper.stopLoading('.loading-holder');
				}, error => {
					$state.go('app.franchiser-companies');
					LoadingHelper.stopLoading('.loading-holder');
					UtilHelper.errorCallback(error);
				})
		}

		function getCategories() {
			return CategoryService
				.getAll()
				.then(success => {
					vm.categories = success.Registers;
				}, error => {
					UtilHelper.errorCallback(error);
				})
		}

		function getEconomicGroups() {
			return CompanyEconomicGroupService
				.getAll()
				.then(success => {
					vm.economicGroups = success.Registers;
				}, error => {
					UtilHelper.errorCallback(error);
				})
		}

		function getClusters() {
			return ClusterService
				.getAll()
				.then(success => {
					vm.clusters = success.Registers;
				}, error => {
					UtilHelper.errorCallback(error);
				})
		}

		function getRegionals() {
			return RegionalService
				.getAll()
				.then(success => {
					vm.regionals = success.Registers;
				}, error => {
					UtilHelper.errorCallback(error);
				})
		}

		function getStatus() {
			return CompanyStatusService
				.getAll()
				.then(success => {
					vm.status = success.Registers;
				}, error => {
					UtilHelper.errorCallback(error);
				})
		}

		function getStates() {
			return StateService
				.getAll()
				.then(success => {
					vm.states = success.filter(state => (state.Id != 0));
				}, error => {
					UtilHelper.errorCallback(error);
				})
		}

		function initVars() {
			const loggedUserData = AuthenticationService.getUser();

			vm.showExtraData = false;
			vm.companyData = {
				CompanyEmails: [],
				CompanyPhones: [],
				Active: true
			};

			vm.canUserHandlePerson = AuthenticationService.getCompanyDataByPermissionGroupAndModuleId(loggedUserData.PermissionGroup.Id, SYSTEM_MODULES.FRANCHISER_PEOPLE).length > 0;
			vm.selectedTab = 1;
			vm.cityPlaceholder = 'ESCOLHA UM ESTADO';
		}

		function init() {
			initVars();

			LoadingHelper.startLoading('.loading-holder');

			$q.all([getStates(), getCategories(), getEconomicGroups(), getClusters(), getRegionals(), getStatus()])
				.then(() => {
					getCompany();
				})
		}
	}
}());